export default __webpack_public_path__ + "static/media/3.ace5bb9b.jpg";